import { TFunction } from 'i18next'

export const getInitialConcepts = (t: TFunction) => [{ key: 'none', value: 'None', text: t('global.nofilters') }]

export const getPackageUsageStatus = (t: TFunction) => [
  { key: 'none', value: 'None', text: t('global.nofilters') },
  { key: 'ECOMM_INACTIVE', value: 'ECOMM_INACTIVE', text: t('global.inactive') },
  { key: 'ECOMM_ACTIVE', value: 'ECOMM_ACTIVE', text: t('global.package_enabled') },
  { key: 'ECOMM_NOT_OFFERED', value: 'ECOMM_NOT_OFFERED', text: t('global.not_requested') },
  { key: 'DELETED', value: 'DELETED', text: t('global.deleted') }
]

export const getActivationStatusOptions = (t: TFunction) => [
  { key: 'none', value: 'None', text: t('global.nofilters') },
  { key: 'EMAIL_SENT', value: 'EMAIL_SENT', text: t('global.email_sent') },
  { key: 'OFFER_ACCEPTED', value: 'OFFER_ACCEPTED', text: t('global.offer_accepted') },
  { key: 'COMPLETED', value: 'COMPLETED', text: t('global.completed') }
]
